/**
 * The browser's `@/lib/auth`: the same exports as `apps/mobile/src/lib/auth.ts`.
 *
 * The phone keeps its session cookie in the secure store and hands it to every
 * request by name, because React Native has no cookie jar. A browser has one,
 * and forbids a script from setting the `Cookie` header at all. So the session
 * cookie stays where Better Auth put it, every same-origin request carries it,
 * and `getCookie()` answers the empty string the phone's call sites pass along
 * (the browser drops a forbidden header without a word).
 */
import { AUTH_BASE_PATH } from '@alluzo/shared';
import { emailOTPClient, inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

import { apiBaseUrl } from '@/lib/api';

export const authEndpoint = `${apiBaseUrl}${AUTH_BASE_PATH}`;

export const authClient = createAuthClient({
  baseURL: apiBaseUrl,
  basePath: AUTH_BASE_PATH,
  plugins: [
    inferAdditionalFields({
      user: {
        timezone: { type: 'string', required: false },
        locale: { type: 'string', required: false },
        region: { type: 'string', required: false },
        localeCurrency: { type: 'string', required: false },
        agentVoice: { type: ['female', 'male'], required: false },
        // The app language, which OS also speaks (APP_LANGUAGES). Null until picked.
        appLanguage: { type: 'string', required: false },
        // How OS opens for a new conversation: live mode (the default) or chat mode.
        osOpensIn: { type: ['live', 'chat'], required: false },
      },
    }),
    // The address-verification code. Only the web asks for it so far; see
    // apps/server/src/auth.ts for why the phone does not yet.
    emailOTPClient(),
  ],
});

export const { useSession, signIn, signUp, signOut } = authClient;

/** The browser sends the session cookie itself. See the header. */
export const getCookie = (): string => '';
